'use client'

export type ToastKind = 'progress' | 'success' | 'error' | 'info'

export type Toast = {
  id: string
  kind: ToastKind
  msg: string
  thumbnail?: string
  /** 0 → 1, uniquement pour kind='progress'. */
  progress?: number
  /** ms ; -1 = permanent. */
  duration?: number
}

let counter = 0

export function showToast(toast: Omit<Toast, 'id'>): string {
  const id = `t-${Date.now()}-${++counter}`
  if (typeof window === 'undefined') return id
  window.dispatchEvent(new CustomEvent('blc-toast', {
    detail: { action: 'add', toast: { id, ...toast } },
  }))
  return id
}

export function updateToast(id: string, patch: Partial<Omit<Toast, 'id'>>) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('blc-toast', {
    detail: { action: 'update', id, patch },
  }))
}

export function dismissToast(id: string) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('blc-toast', {
    detail: { action: 'remove', id },
  }))
}
